module.exports = __webpack_public_path__ + "img/CM-SL-CA-Subaru-Established.3e5b727b.jpg";